__turbopack_context__.v({
  "aurora": "aurora-text-module__kyup-q__aurora",
  "auroraText": "aurora-text-module__kyup-q__auroraText",
});
